import { Spinner, SpinnerProps } from "@amzn/awsui-components-console";
import React from "react";

export interface LoadingSpinnerProps {
  height?: string;
  size?: SpinnerProps.Size;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  height = "100%",
  size = "large",
}) => (
  <div
    style={{
      height,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Spinner size={size} />
  </div>
);

export default LoadingSpinner;
